// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import Vuex from "vuex";

import App from "./App";
import router from "./router/router";
import axios from "axios";
Vue.prototype.$axios = axios;
import store from "./store";
import MintUI from "mint-ui";
import fastClick from "fastclick";
import "lib-flexible";
//引入整个icons,
import "./icons";
import "./style/reset.css";
import "mint-ui/lib/style.css";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";

Vue.use(ElementUI);
Vue.config.productionTip = false;
Vue.use(Vuex);
Vue.use(MintUI);
if ("addEventListener" in document) {
  document.addEventListener(
    "DOMContentLoaded",
    function() {
      fastClick.attach(document.body);
    },
    false
  );
}

fastClick.prototype.focus = function(targetElement) {
  let length;
  if (
    targetElement.setSelectionRange &&
    targetElement.type.indexOf("number") !== 0 &&
    targetElement.type !== "time" &&
    targetElement.type !== "month"
  ) {
    length = targetElement.value.length;
    targetElement.focus();
    targetElement.setSelectionRange(length, length);
  } else {
    targetElement.focus();
  }
};
// 页面跳转
// if (window.navigator.userAgent.indexOf("Windows") > -1) {
//   console.log("电脑版");
//   // window.open('www.zhongdaokj.com')
//   // 跳转电脑版链接
// } else {
//   console.log("手机版");
//   // 跳转手机版链接
//   window.open("http://phone.zhongdaokj.com", "_self");
// }
var os = (function() {
  var ua = navigator.userAgent,
    isWindowsPhone = /(?:Windows Phone)/.test(ua),
    isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone,
    isAndroid = /(?:Android)/.test(ua),
    isFireFox = /(?:Firefox)/.test(ua),
    isTablet =
      /(?:iPad|PlayBook)/.test(ua) ||
      (isAndroid && !/(?:Mobile)/.test(ua)) ||
      (isFireFox && /(?:Tablet)/.test(ua)),
    isPhone = /(?:iPhone)/.test(ua) && !isTablet,
    isPc = !isPhone && !isAndroid && !isSymbian
  return {
    isTablet: isTablet,
    isPhone: isPhone,
    isAndroid: isAndroid,
    isPc: isPc
  }
})()
// if (os.isPc) {
//   console.log('电脑版')
// } else if (os.isAndroid || os.isPhone) {
//   console.log('手机版')
//   window.open('http://phone.zhongdaokj.com', '_self')
// }
import Router from "vue-router";
const routerPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => error);
};

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js